import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { TextInput } from '@domain-group/fe-co-form-elements';
import Select from '@domain-group/fe-co-select';
import DatePicker from '@domain-group/fe-co-date-picker';
import CalendarIcon from '@domain-group/fe-co-icon/lib/js/calendar';
import * as styles from './availability-date.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fromRange = range => {
  if (range) {
    if (range.min) {
      return {
        type: 'after',
        date: range.min ? moment(range.min) : null
      };
    }
    if (range.max) {
      return {
        type: 'before',
        date: range.max ? moment(range.max) : null
      };
    }
    return {
      type: 'before',
      date: null
    };
  }
  return {
    date: null,
    type: 'before'
  };
};
var toRange = _ref => {
  var date = _ref.date,
    type = _ref.type;
  var keyDate = type === 'before' ? 'max' : 'min';
  var keyNull = keyDate === 'max' ? 'min' : 'max';
  return {
    [keyDate]: date.format('YYYY-MM-DD'),
    [keyNull]: null
  };
};
class AvailabilityDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = fromRange(this.props.value);
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(newProps) {
    if (!isEqual(this.props.value, newProps.value)) {
      this.setState(fromRange(newProps.value));
    }
  }
  buildRange() {
    if (this.state.date) {
      var range = toRange(this.state);
      this.props.onChange({
        [this.props.name]: range
      });
    }
  }
  dateInputBox() {
    return ___EmotionJSX(TextInput, {
      className: "allhomes-search-more-options__input",
      name: "allhomes-search-more-options__availability-date",
      type: "text",
      icon: ___EmotionJSX(CalendarIcon, null),
      value: this.state.date ? this.state.date.format('DD/MM/YYYY') : '',
      placeholder: "Select date",
      readOnly: true
    });
  }
  render() {
    return ___EmotionJSX("div", {
      css: styles.filter
    }, ___EmotionJSX("div", {
      css: styles.title
    }, "Available date"), ___EmotionJSX(Select, {
      css: styles.select,
      label: "select-available-date",
      options: [{
        value: 'before',
        label: 'Before'
      }, {
        value: 'after',
        label: 'After'
      }],
      onChange: item => {
        this.setState({
          type: item.value
        }, this.buildRange);
      },
      value: this.state.type,
      labelHidden: true
    }), ___EmotionJSX(DatePicker, {
      trigger: this.dateInputBox(),
      selected: this.state.date ? this.state.date.toDate() : null,
      onChange: date => {
        this.setState({
          date: moment(date)
        }, this.buildRange);
      },
      alignToTrigger: this.props.embedded ? 'right' : 'centre'
    }));
  }
}
AvailabilityDate.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string
  }),
  embedded: PropTypes.bool
};
AvailabilityDate.defaultProps = {
  name: 'availability',
  onChange: () => {},
  value: {
    min: null,
    max: null
  },
  embedded: false
};
export default AvailabilityDate;